"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINT = void 0;
exports.ENDPOINT = {
    MY_MEMBER: '/_api/members/v1/members/my?fieldsets=FULL',
    MEMBER_ROLE: (memberId) => `/api/wix-sm/v1/members/${memberId}/role`,
};
//# sourceMappingURL=constants.js.map